import React from "react";
import FolderMenuItem from "./FolderMenuItem";
import { SavedJourney, Folder } from "@/utils/storage/types";

interface FoldersListProps {
  folders: Folder[];
  savedJourneys: SavedJourney[];
  handleSaveToFolder: (folderId: string) => void;
  handleLoad: (id: string) => void;
  handleMoveToFolder: (journeyId: string, folderId: string | null) => void;
}

const FoldersList: React.FC<FoldersListProps> = ({
  folders,
  savedJourneys,
  handleSaveToFolder,
  handleLoad,
  handleMoveToFolder,
}) => {
  return (
    <>
      {folders.map((folder) => {
        const folderJourneys = savedJourneys.filter(journey => journey.folderId === folder.id);
        
        return (
          <FolderMenuItem
            key={folder.id}
            folder={folder}
            folderJourneys={folderJourneys}
            handleSaveToFolder={handleSaveToFolder}
            handleLoad={handleLoad}
            handleMoveToFolder={handleMoveToFolder}
            folders={folders}
          />
        );
      })}
    </>
  );
};

export default FoldersList;
